import { defineComponent as _defineComponent } from 'vue'
import { ref, defineAsyncComponent, computed, getCurrentInstance } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'expandable-content',
  setup(__props) {

const instance = getCurrentInstance();
const vm = instance?.proxy as Vue;

const IconArrow = defineAsyncComponent(() => import("@white-label-icon/icon-arrow"));

const expandableIsActive = ref(false);

const toggleExpandable = () => {
  expandableIsActive.value = !expandableIsActive.value;
};

const expandableContentAriaLabel = computed(() => {
  return expandableIsActive.value
    ? vm.$t('searchParkingMoreInfoModal.hideExpandableContent').toString()
    : vm.$t('searchParkingMoreInfoModal.showExpandableContent').toString();
});

return { __sfc: true,instance, vm, IconArrow, expandableIsActive, toggleExpandable, expandableContentAriaLabel }
}

})